import {Values} from '@wix/devzai-utils-common';
import {DoppeBusinessEntity} from './doppe-business-entity';
import {DoppeAutoEventType} from './doppe-auto-event-type';

export const DoppeEventsExternalDataSourceType = {
    UpcomingAndOldWixEvents: 'LatestWixEvents',
    UpcomingWixEvents: 'UpcomingWixEvents',
    OldWixEvents: 'OldWixEvents',
    UpcomingAndOldHoppEvents: 'UpcomingAndOldHoppEvents',
    UpcomingHoppEvents: 'UpcomingHoppEvents',
    OldHoppEvents: 'OldHoppEvents',
} as const;

export type DoppeEventsExternalDataSourceType = Values<typeof DoppeEventsExternalDataSourceType>;

export type DoppeEventsExternalDataSource =
    | {
    type: typeof DoppeEventsExternalDataSourceType.UpcomingAndOldWixEvents;
} | {
    type: typeof DoppeEventsExternalDataSourceType.UpcomingWixEvents;
} | {
    type: typeof DoppeEventsExternalDataSourceType.OldWixEvents;
}     | {
    type: typeof DoppeEventsExternalDataSourceType.UpcomingAndOldHoppEvents;
} | {
    type: typeof DoppeEventsExternalDataSourceType.UpcomingHoppEvents;
} | {
    type: typeof DoppeEventsExternalDataSourceType.OldHoppEvents;
};


export function doppeEventsExternalDataSourceResolveBusinessEntityReferences(
    externalDataSource: DoppeEventsExternalDataSource
) {
    switch (externalDataSource.type) {
        case DoppeEventsExternalDataSourceType.UpcomingAndOldWixEvents: {
            return {businessEntity: DoppeBusinessEntity.WixAutoEventsList, id: DoppeAutoEventType.UpcomingAndOld}
        }
        case DoppeEventsExternalDataSourceType.UpcomingWixEvents: {
            return {businessEntity: DoppeBusinessEntity.WixAutoEventsList, id: DoppeAutoEventType.Upcoming}
        }
        case DoppeEventsExternalDataSourceType.OldWixEvents: {
            return {businessEntity: DoppeBusinessEntity.WixAutoEventsList, id: DoppeAutoEventType.Old}
        }
        case DoppeEventsExternalDataSourceType.UpcomingAndOldHoppEvents: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoEventsList, id: DoppeAutoEventType.UpcomingAndOld}
        }
        case DoppeEventsExternalDataSourceType.UpcomingHoppEvents: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoEventsList, id: DoppeAutoEventType.Upcoming}
        }
        case DoppeEventsExternalDataSourceType.OldHoppEvents: {
            return {businessEntity: DoppeBusinessEntity.HoppAutoEventsList, id: DoppeAutoEventType.Old}
        }
    }
}